"use strict";

class DeveloperUsersController {

    constructor(SSHttpService, SSUtilService, SSAlertService, SSUserService, SSDateService) {
        const self = this;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSDateService = SSDateService;

        self.data = SHOWSUITE.data;

        self.has_access = false;

        self.user = self.SSUserService.getUser();
        if (!self.user) {
            self.SSUserService.showLoginModal();
        }

        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.filters = {
            limit: 5,
            filter_on: '',
            role_id: '',
            status: ''
        };

        self.current = 1;

        // Predicate functions for client-side filtering via Angular's |filter: pipe.
        // Defined here (not as class methods) so they close over `self` — Angular calls
        // filter predicates as free functions without a `this` context.
        self.searchFilterFn = function (user) {
            const term = (self.filters.filter_on || '').toString().trim().toLowerCase();
            if (!term) return true;
            return ['display_name', 'email', 'phone1'].some(function (key) {
                const v = user[key];
                return v != null && String(v).toLowerCase().indexOf(term) !== -1;
            });
        };

        self.roleFilterFn = function (user) {
            const roleId = self.filters.role_id;
            if (roleId === '' || roleId == null) return true;
            if (user.role_id != null) {
                return String(user.role_id) === String(roleId);
            }
            const role = (self.developer_roles || []).find(function (r) {
                return String(r.id) === String(roleId);
            });
            if (!role) return false;
            return user.role === role.name;
        };

        self.statusFilterFn = function (user) {
            const filterVal = self.filters.status;
            if (filterVal === '' || filterVal == null) return true;
            // Status semantics (match SSUserService.getStatusText/getStatusClass):
            //   null / '' / 0 -> Pending
            //   1             -> Active
            //   2             -> Inactivated
            const fv = String(filterVal);
            if (fv === '0') {
                return user.status == null
                    || user.status === ''
                    || String(user.status) === '0';
            }
            if (fv === '1') {
                return String(user.status) === '1';
            }
            if (fv === '2') {
                return String(user.status) === '2';
            }
            return false;
        };

        self.getDeveloperUsers();
    }

    getDeveloperUsers() {
        const self = this;

        self.users = null;

        // Fetch-all: user counts are small (<50). Filtering and paging happen client-side.
        const params = {
            offset: 0,
            limit: 10000,
            send_total_count: 1
        };

        let url = 'sec/developer/users';

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data) {
                self.visitorregisters = response.data.visitors;
                self.developer_roles = response.data.developer_roles;

                // Root-account visibility is gated server-side (WEB-3866): the API only
                // returns root accounts to root callers, so any root row present here is
                // already meant for this caller. Root rows are flagged in the list via a
                // "ROOT" indicator instead of being hidden client-side.
                const users = response.data.users || [];
                self.users = users;
                self.users_master = angular.copy(users);
                self.users_backup = angular.copy(users);
                self.visitor_register_master = angular.copy(self.visitorregisters);
                self.visitor_register_backup = angular.copy(self.visitorregisters);

                if (self.users_master) {
                    self.user_roles = [];
                    $.each(self.users_master, function (index, value) {
                        self.user_roles.push(value.role);
                    });
                    const uniqueNames = [];
                    $.each(self.user_roles, function (i, el) {
                        if ($.inArray(el, uniqueNames) === -1) uniqueNames.push(el);
                    });
                    self.user_roles = uniqueNames;
                }
            }
        });
    }

    applyFilters() {
        const self = this;
        self.current = 1;
    }

    updateRowLimit() {
        const self = this;
        self.current = 1;
    }

    clearFilters() {
        const self = this;

        self.filters.filter_on = '';
        self.filters.role_id = '';
        self.filters.status = '';
        self.filters.limit = 5;
        self.current = 1;
    }

}

DeveloperUsersController.$inject = ['SSHttpService', 'SSUtilService', 'SSAlertService', 'SSUserService','SSDateService'];
app.controller('DeveloperUsersController', DeveloperUsersController);
